
import Vue from 'vue'
import { Prop, Component } from 'vue-property-decorator'

@Component
export default class PaymentRequiredModal extends Vue {
  @Prop({ type: Object, default: () => ({}) })
  readonly corrections: any

  paymentRequired =  false
  
  makePayment() {
    this.paymentRequired = false
    this.$emit('pay')
  }

  open() {
    this.paymentRequired = true
  }

  close() {
    this.paymentRequired = false
  }
}
